import PageAccordions from './page-accordions.js';

export default class ApiParams {
  constructor(customAccordions) {
    this.apiParamsPanelHeader = $(
      '.section.api-method-parameters > .accordion > .panel > .panel-heading'
    );
    this.apiParamsPanelHeader
      .find('.title')
      .attr('collapse-status', 'Collapse');
    this.customAccordions = customAccordions;
  }

  listenEvents() {
    const self = this;
    this.apiParamsPanelHeader.on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const panelHeader = $(this);
      const allCollapsed =
        panelHeader.find('.title').attr('collapse-status') === 'Expand';
      const apiParamsAccordions = new PageAccordions(
        '.section.api-method-parameters .panel-body .accordion'
      );

      panelHeader
        .find('.title')
        .attr('collapse-status', allCollapsed ? 'Collapse' : 'Expand');
      if (allCollapsed) {
        apiParamsAccordions.expandAll();
        self.customAccordions.expandAll();
      } else {
        apiParamsAccordions.collapseAll();
        self.customAccordions.collapseAll();
      }
    });
  }

  stopListening() {
    this.apiParamsPanelHeader.off('click');
  }
}
